/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { useEffect, useState } from "react";
import { getClientes, getCliente } from "../../../project/services/ClienteService";
import ClienteDialog from "./../cliente/ClienteDialog";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import { parse } from 'date-fns';
import { calculateDifferenceYears } from "../../utils/utils";

const initialSearchData = {
  documento: "",
  nombre: "",
  apellido: "",
  rows: 10,
  first: 0,
};
//
// ################################################################################
//
const BuscarClienteDialog = ({ open, onClose, onSelect, canCreateEdit }) => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [clientes, setClientes] = useState([]);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [openDialogCliente, setOpenDialogCliente] = useState(false);

  const tableColumns = [
    {
      field: "tipoNumeroDocumento",
      headerName: "Documento",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_tipo_documento + " - " + params.row.num_doc;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "nombre",
      headerName: "Nombre",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "apellido",
      headerName: "Apellido",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.apellido;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Seleccionar",
      headerAlign: "center",
      align: "center",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="seleccionar">
            <IconButton
              size="small"
              aria-label="select"
              onClick={() => handleClickCliente(params.row, "select")}
            >
              <CheckIcon />
            </IconButton>
          </Tooltip>

          {canCreateEdit && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickCliente(params.row, "update")}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setRowsPerPage(10);
    setCurrentPage(0);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      nombre: searchData.nombre,
      apellido: searchData.apellido,
      numeroDocumento: searchData.documento,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getClientes(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setClientes(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleClickCliente = (parRow, parAction) => {
    let _itemCrud = {};

    if (parAction === "select") {
      onSelect(parRow);
    } else if (parAction === "update") {
      const loadItem = async () => {

        setIsDoingSomething(true);
        const response = await getCliente({ id: parRow.id });
        setIsDoingSomething(false);

        if (response.ok) {
          let _response = response.data.data;

          _itemCrud = {
            id: _response.id,
            tipoDocumento: _response.id_tipo_documento,
            numeroDocumento: _response.num_doc,
            nombre: _response.nombre,
            apellido: _response.apellido,
            fechaNacimiento: _response.fecha_nac ? parse(_response.fecha_nac, 'dd/MM/yyyy', new Date()) : null,
            edadActual: calculateDifferenceYears(parse(_response.fecha_nac, 'dd/MM/yyyy', new Date())),
            genero: _response.id_genero,
            numeroCuitCuil: _response.numero_cuit_cuil,
            domicilio: _response.domicilio,
            localidad: _response.localidad,
            departamento: _response.id_departamento ?? "",
            provincia: _response.id_provincia ?? "",
            pais: _response.id_pais ?? "",
            codigoPostal: _response.codigo_postal,
            eMail: _response.email,
            telefonoMovil: _response.telefono_movil,
            telefonoFijo: _response.telefono,
          };

          setActionCrud(parAction);
          setItemCrud(_itemCrud);
          setOpenDialogCliente(true);
        } else {
          setMessage({
            severity: response.messageSeverity,
            messageText: response.messageText,
          });
          setShowMessage(true);
          return;
        }
      };
      loadItem();
    } else {
      setActionCrud(parAction);
      setItemCrud(_itemCrud);
      setOpenDialogCliente(true);
    }
  };
  //
  // ################################################################################
  //
  const handleDialogClienteSave = () => {
    load();
    setOpenDialogCliente(false);
  };
  //
  // ################################################################################
  //
  const handleDialogClienteClose = () => {
    setOpenDialogCliente(false);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        maxWidth="lg"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Búsqueda de Clientes
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>

          <Paper elevation={1} >
            <Box sx={{ mx: 1, px: 1, pb: 1 }}>

              <Grid container spacing={1} sx={{ pb: 1 }}>
                <Grid item xs={12} md={4}>
                  <TextField
                    id="documento"
                    sx={{ width: "100%" }}
                    inputProps={{
                      autoComplete: "off",
                      maxLength: 8,
                    }}
                    variant="outlined"
                    size="small"
                    name="documento"
                    label="Documento"
                    value={searchData.documento}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{
                      autoComplete: "off",
                      maxLength: 30
                    }}
                    variant="outlined"
                    size="small"
                    name="nombre"
                    label="Nombre"
                    value={searchData.nombre}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{
                      autoComplete: "off",
                      maxLength: 30
                    }}
                    variant="outlined"
                    size="small"
                    name="apellido"
                    label="Apellido"
                    value={searchData.apellido}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                {canCreateEdit && (
                  <Grid item xs={12} md={12} lg={1}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Tooltip title="Nuevo Cliente">
                        <Button
                          fullWidth
                          sx={{ mt: 2 }}
                          variant="contained"
                          size="small"
                          onClick={() => handleClickCliente({}, "new")}
                          startIcon={<AddCircleOutlineOutlinedIcon />}
                        >
                          Nuevo
                        </Button>
                      </Tooltip>
                    </Box>
                  </Grid>
                )}

                <Grid item xs={12} md={12} lg={1.5}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="buscar">
                      <Button
                        fullWidth
                        sx={{ mt: 2 }}
                        variant="contained"
                        size="small"
                        onClick={handleBuscar}
                        startIcon={<SearchIcon />}
                      >
                        Buscar
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12} md={12} lg={1.5}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="limpiar filtros de búsqueda">
                      <Button
                        fullWidth
                        sx={{ mt: 2 }}
                        variant="outlined"
                        size="small"
                        onClick={handleLimpiar}
                        startIcon={<CleaningServicesIcon />}
                      >
                        Limpiar
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Paper>

          <Paper elevation={3}>
            <DataGrid
              rows={clientes}
              columns={tableColumns}
              {...tableOptions}
            />
          </Paper>
        </DialogContent>
      </Dialog>

      {/* >>>> Dialog */}

      {openDialogCliente && (
        <ClienteDialog
          onSave={handleDialogClienteSave}
          onClose={handleDialogClienteClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default BuscarClienteDialog;
